import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_UploadDocuments = _resolveComponent("UploadDocuments")!
  const _component_IncomingOutgoingPaymentExpense = _resolveComponent("IncomingOutgoingPaymentExpense")!
  const _component_DocumentReconciliator = _resolveComponent("DocumentReconciliator")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_document = _resolveComponent("document")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.dialog,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dialog) = $event)),
      maxWidth: "1000px",
      title: _ctx.incomingOutgoingPaymentBTDialogTitle,
      previousDisplay: _ctx.displayPrevious,
      onPrevious: _cache[12] || (_cache[12] = ($event: any) => (_ctx.previous())),
      actions: _ctx.mainDialogActions,
      "min-width": "70vw"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window, {
          modelValue: _ctx.wizardStep,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.wizardStep) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_window_item, { value: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  style: {"font-weight":"bold","flex-wrap":"nowrap"},
                  class: _normalizeClass({ 'px-3': _ctx.$vuetify.display.mobile })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { class: "flex-grow-1 flex-shrink-0" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.selectedBankTransaction.wordingDisplay ||
                                _ctx.selectedBankTransaction.wordingOriginal), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      style: _normalizeStyle({
                                color: _ctx.selectedBankTransaction.amout < 0 ? 'red' : '',
                            }),
                      class: "d-flex justify-end align-center flex-grow-0 flex-shrink-1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(_ctx.selectedBankTransaction.amount, undefined)), 1)
                      ]),
                      _: 1
                    }, 8, ["style"])
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_v_divider, { class: "my-1" }),
                (_ctx.selectedBankTransaction.accountingLines)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.selectedBankTransaction.accountingLines, (al, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (!al.accountableAccount.name.startsWith('512'))
                          ? (_openBlock(), _createBlock(_component_v_row, {
                              key: 0,
                              class: "pb-0 px-3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(al.accountableAccount.shortDescription ||
                                        al.accountableAccount.description ||
                                        al.accountableAccount.name), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_col, {
                                  style: _normalizeStyle(al.amountSigned < 0 ? 'color:red' : ''),
                                  class: "d-flex justify-end"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(al.amountSigned, undefined)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["style"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { class: "d-flex justify-end" }, {
                      default: _withCtx(() => [
                        (
                                    !!_ctx.toValidateReconciliationId &&
                                    _ctx.toValidateDocument &&
                                    _ctx.linkedDocumentId
                                )
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.documentDialog = true)),
                              class: "mr-2",
                              loading: _ctx.validateLoading,
                              size: "small"
                            }, {
                              default: _withCtx(() => _cache[14] || (_cache[14] = [
                                _createTextVNode(" Valider le justificatif ")
                              ])),
                              _: 1
                            }, 8, ["loading"]))
                          : _createCommentVNode("", true),
                        (_ctx.alreadyAllocated)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 1,
                              onClick: _ctx.deallocateBankTransactions,
                              class: "mr-2",
                              size: "small"
                            }, {
                              default: _withCtx(() => _cache[15] || (_cache[15] = [
                                _createTextVNode(" Retirer l'affectation ")
                              ])),
                              _: 1
                            }, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (!!_ctx.linkedDocumentId || !!_ctx.toValidateReconciliationId)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 2,
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.documentDialog = true)),
                              disabled: !_ctx.linkedDocumentId && !_ctx.toValidateDocument,
                              size: "small"
                            }, {
                              default: _withCtx(() => _cache[16] || (_cache[16] = [
                                _createTextVNode(" Voir le justificatif ")
                              ])),
                              _: 1
                            }, 8, ["disabled"]))
                          : (!_ctx.toValidateReconciliationId)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 3,
                                onClick: _ctx.goToChoiceStep,
                                size: "small"
                              }, {
                                default: _withCtx(() => _cache[17] || (_cache[17] = [
                                  _createTextVNode(" Ajouter un justificatif ")
                                ])),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list, {
                  subheader: "",
                  lines: "two"
                }, {
                  default: _withCtx(() => [
                    (_ctx.displayPurchasesOption)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 0,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => {
                                _ctx.wizardStep = 2;
                                _ctx.documentType = 'PURCHASE_INVOICE';
                            }),
                          class: _normalizeClass(["mb-2 rounded-xl", !_ctx.$vuetify.display.mobile ? '' : 'px-2']),
                          border: ""
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_btn_next)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[18] || (_cache[18] = [
                                _createTextVNode("Facture d'achat")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["class"]))
                      : _createCommentVNode("", true),
                    (_ctx.displaySalesOption)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 1,
                          onClick: _cache[3] || (_cache[3] = ($event: any) => {
                                _ctx.wizardStep = 2;
                                _ctx.documentType = 'SALES_INVOICE';
                            }),
                          class: _normalizeClass(["mb-2 rounded-xl", !_ctx.$vuetify.display.mobile ? '' : 'px-2']),
                          border: ""
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_btn_next)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[19] || (_cache[19] = [
                                _createTextVNode("Facture de vente")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["class"]))
                      : _createCommentVNode("", true),
                    (_ctx.displayMiscellaneousOption)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 2,
                          onClick: _cache[4] || (_cache[4] = ($event: any) => {
                                _ctx.wizardStep = 2;
                                _ctx.documentType = 'MISCELLANEOUS';
                            }),
                          class: _normalizeClass(["mb-2 rounded-xl", !_ctx.$vuetify.display.mobile ? '' : 'px-2']),
                          disabled: !_ctx.enableLinkWithExistingDocument,
                          border: ""
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_btn_next)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[20] || (_cache[20] = [
                                _createTextVNode("Document divers")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["class", "disabled"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list, {
                  subheader: "",
                  lines: "two"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item, {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => {
                                _ctx.setDocumentTypeAuto();
                                _ctx.wizardStep = 5;
                            }),
                      class: _normalizeClass(["mb-2 rounded-xl", !_ctx.$vuetify.display.mobile ? '' : 'px-2']),
                      disabled: !_ctx.enableLinkWithExistingDocument,
                      border: ""
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_v_btn_next)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.secondStepLinkTitle), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["class", "disabled"]),
                    (
                                !_ctx.alreadyAllocated &&
                                (_ctx.documentType === 'PURCHASE_INVOICE' ||
                                    _ctx.documentType === 'SALES_INVOICE')
                            )
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 0,
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.wizardStep = 4)),
                          class: _normalizeClass(["mb-2 rounded-xl", !_ctx.$vuetify.display.mobile ? '' : 'px-2']),
                          border: ""
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_btn_next)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[21] || (_cache[21] = [
                                _createTextVNode("Affecter sans facture")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["class"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 3 }, {
              default: _withCtx(() => [
                (_ctx.amountSigned)
                  ? (_openBlock(), _createBlock(_component_UploadDocuments, {
                      key: 0,
                      showFirstPrevious: false,
                      companyId: _ctx.selectedCompany.id,
                      documentType: _ctx.documentType,
                      documentStatus: _ctx.documentStatus,
                      multiple: false,
                      freeTag: false,
                      gDrive: true,
                      showActionsBtn: true,
                      onNewDocument: _ctx.onNewDocument
                    }, null, 8, ["companyId", "documentType", "documentStatus", "onNewDocument"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 4 }, {
              default: _withCtx(() => [
                (_ctx.wizardStep === 4)
                  ? (_openBlock(), _createBlock(_component_IncomingOutgoingPaymentExpense, {
                      key: 0,
                      companyId: _ctx.selectedCompany.id,
                      mode: _ctx.mode,
                      initGrossAmount: Math.abs(_ctx.selectedBankTransaction.amount),
                      initDate: _ctx.selectedBankTransaction.dateDebit,
                      initTitle: _ctx.selectedBankTransaction.wordingOriginal,
                      actions: _ctx.expenseActions,
                      bankTransactionId: _ctx.selectedBankTransaction.id,
                      onExpenseCreated: _cache[7] || (_cache[7] = ($event: any) => (_ctx.bankTransactionUpdated()))
                    }, null, 8, ["companyId", "mode", "initGrossAmount", "initDate", "initTitle", "actions", "bankTransactionId"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 5 }, {
              default: _withCtx(() => [
                (_ctx.wizardStep === 5)
                  ? (_openBlock(), _createBlock(_component_DocumentReconciliator, {
                      key: 0,
                      companyId: _ctx.selectedCompany.id,
                      miscellaneousMode: _ctx.documentType === 'MISCELLANEOUS' ? true : false,
                      thirdPartyCompanyId: _ctx.thirdCompanyIdForDocumentReconciliator,
                      documentType: _ctx.documentType,
                      amountSigned: _ctx.bankTransactionAmount,
                      onAddAccountingLine: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addAccountingLine($event))),
                      onAddDocument: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addDocument($event)))
                    }, null, 8, ["companyId", "miscellaneousMode", "thirdPartyCompanyId", "documentType", "amountSigned"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 6 }),
            _createVNode(_component_v_window_item, { value: 7 })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue", "title", "previousDisplay", "actions"]),
    (_ctx.documentDialog)
      ? (_openBlock(), _createBlock(_component_oss_dialog, {
          key: 0,
          modelValue: _ctx.documentDialog,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.documentDialog) = $event)),
          withoutHeader: true,
          transition: "dialog-bottom-transition"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { class: "d-flex justify-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  style: {"overflow-y":"auto"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_document, {
                      mode: 'Reconciliation',
                      companyId: _ctx.selectedCompany.id,
                      id: _ctx.linkedDocumentId || _ctx.toValidateDocument.id,
                      "dark-mode": true,
                      onTaskEnded: _ctx.onDocumentValidated
                    }, null, 8, ["companyId", "id", "onTaskEnded"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}